import { useStore } from '@store';
import styles from './tellStoryLanguage.module.scss';
import notFoundImage from '@assets/images/ai4.png';
import { Skeleton } from 'antd/lib';
import { GoChevronRight } from 'react-icons/go';
import { useTellStoryLanguage } from 'src/core/repo/tellStory/useCase';
import { ITellStoryLanguageRes } from 'src/core/repo/tellStory/type';

interface Props {
  handleClick: (language: ITellStoryLanguageRes) => void;
}

const TellStoryLanguage = ({ handleClick }: Props) => {
  const { data: languages, isLoading } = useTellStoryLanguage();
  const { theme = 'day' } = useStore();

  return (
    <div className={styles.wrapper}>
      {!languages ? (
        <div className={styles.not_found_wrapper}>
          <img src={notFoundImage} alt="not found image" />
          <h1>Nothing found for you ...</h1>
        </div>
      ) : isLoading ? (
        <div className={styles.options}>
          {Array.from({ length: 4 }, (_, i) => (
            <Skeleton.Input className={styles.option} active key={i} />
          ))}
        </div>
      ) : (
        <div className={styles.container}>
          <div className={styles.description_wrapper}>
            <h1 style={{ color: theme === 'day' ? '#000' : '#fff' }}>
              Select language
            </h1>
            <p style={{ color: theme === 'day' ? '#333' : '#fff' }}>
              Please select your preferred language so we can provide you with
              the best experience
            </p>
          </div>
          <div className={styles.options}>
            {languages.map((item, idx) => (
              <div
                onClick={() => handleClick(item)}
                key={idx}
                className={styles.option}>
                <h3>{item.Lang}</h3>
                <div className={styles.option_action}>
                  <GoChevronRight
                    className={styles.chevron_right}
                    size={24}
                    color={'#292D32'}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TellStoryLanguage;
